import { useCallback, useRef } from 'react';

const useCallbackDebounce = (callback: (...args: any[]) => void, delay: number) => {
  const timeoutRef = useRef<number>();

  return useCallback(
    (...args: any) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = window.setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );
};

export default useCallbackDebounce;
